// extracted by mini-css-extract-plugin
export default {"wrapper":"ValuePrincipal_wrapper__epDG6","icon":"ValuePrincipal_icon__7uS9K","avatar":"ValuePrincipal_avatar__ZqiKt"};